var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cancellation-policy" }, [
    _c("div", { staticClass: "title mb-3" }, [
      _vm._v(
        "\n        " + _vm._s(_vm.voMsg("tpl.cancellation.title")) + "\n    "
      )
    ]),
    _vm._v(" "),
    _c("ul", { staticClass: "tick-li" }, [
      _c("li", [
        _c("span", { staticClass: "li-title" }, [
          _vm._v(_vm._s(_vm.voMsg("tpl.cancellation.bestPrice")))
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(_vm._s(_vm.voMsg("tpl.cancellation.bestPriceWeb")))
      ]),
      _vm._v(" "),
      _c("li", [
        _c("span", { staticClass: "li-title" }, [
          _vm._v(_vm._s(_vm.voMsg("tpl.cancellation.service")))
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(_vm._s(_vm.voMsg("tpl.cancellation.emailService")))
      ]),
      _vm._v(" "),
      _c("li", [
        _c("span", { staticClass: "li-title" }, [
          _vm._v(_vm._s(_vm.voMsg("tpl.cancellation.guestApp")))
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(_vm._s(_vm.voMsg("tpl.cancellation.guestAppInfo")))
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }